// extracted by mini-css-extract-plugin
export var menuIcon = "_t7-0";
export var menuIconInline = "_t7-1";